import { Link } from 'react-router-dom';
import { homeHero } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${homeHero.heroImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/70" />

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <p className="text-accent-400 font-label text-sm md:text-base tracking-widest mb-4 animate-fadeIn">
          OFFICIAL FAN SITE
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-4 tracking-tight">
          {homeHero.name}
        </h1>
        <p className="text-lg md:text-xl text-background-50/80 font-heading mb-2 max-w-xl mx-auto">
          {homeHero.tagline}
        </p>
        <p className="text-sm md:text-base text-background-50/50 mb-8">
          {homeHero.subTagline}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap text-sm"
          >
            <i className="ri-film-line" />
            浏览作品
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full backdrop-blur-sm transition-all duration-300 whitespace-nowrap text-sm border border-background-50/20"
          >
            <i className="ri-information-line" />
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}